<!--
 * @Author: zb
 * @LastEditors: 请在根目录下.vscode改成你的名字
 * @Date: 2019-08-08 19:37:56
 * @LastEditTime: 2019-09-26 21:41:50
 * @Version: 1.0
 * @Description: 推荐运力页面
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks: 备注
 -->

<template>
  <el-dialog
    :visible.sync="viewManager.visible"
    title="运力推荐"
    width="80%"
    @close="viewManager.close"
  >
    <div v-loading="viewManager.loading" class="recommend-dialog-head">
      <div class="slider-list">
        <div :class="{ 'selected': !recommendState}" class="item" @click="toggleRecommendState">智能推荐</div>
        <div :class="{ 'selected': recommendState}" class="item" @click="toggleRecommendState">常规推荐</div>
      </div>

      <div v-show="!recommendState" class="recommend-data">
        <div class="recommend-data-header">
          <ul>
            <li>公司名称</li>
            <li>联系人</li>
            <li>联系人电话</li>
            <li>公司地址</li>
            <li>路线</li>
            <li>运输方式</li>
            <li>承载能力</li>
            <li>运输品类</li>
            <li>操作</li>
          </ul>
        </div>
        <div class="recommend-data-body">
          <template v-if="recommendData.length===0 && !viewManager.loading">
            <div class="no-data-info">
              <font>暂无匹配数据</font>
            </div>
          </template>
          <template v-for="(item, index) of recommendData">
            <div :key="index" class="data-item">
              <ul>
                <li :title="item.companyName">{{ item.companyName }}</li>
                <li :title="item.shipmentName">{{ item.shipmentName }}</li>
                <li :title="item.shipmentTel">{{ item.shipmentTel }}</li>
                <li :title="item.companyAddress">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.companyAddress"
                    placement="top"
                  >
                    <span>{{ item.companyAddress }}</span>
                  </el-tooltip>
                </li>
                <li :title="item.startPlaceLabel+'至'+item.stopPlaceLabel">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.startPlaceLabel + '至' + item.stopPlaceLabel"
                    placement="top"
                  >
                    <span>{{ item.startPlaceLabel }} 至 {{ item.stopPlaceLabel }}</span>
                  </el-tooltip>
                </li>
                <li :title="item.transportTypeLabel">{{ item.transportTypeLabel }}</li>
                <li :title="item.weight">{{ item.weight }}</li>
                <li :title="item.goodsTypeLabel">{{ item.goodsTypeLabel }}</li>
                <li>
                  <el-button
                    class="yellow"
                    type="text"
                    @click="collect(item)"
                  >{{ item.favoritesFlag==='1'?'已收藏':'未收藏' }}</el-button>
                  <el-divider direction="vertical" />
                  <el-button
                    style="width: 4rem"
                    :class="[{gray:item.inviteType===1},{orange:item.inviteType!==1}]"
                    type="text"
                    :disabled="item.inviteType !== 0"
                    @click="invitationOfferShow(item)"
                  >{{ item.inviteType=='2'? Number.parseInt(item.isRejectOffer)? '拒绝报价':'已报价' :item.inviteType=='1'?'已邀请':'邀请报价' }}</el-button>
                  <!-- <el-divider direction="vertical" />
                  <el-button class="red" type="text" @click="agreeBid(item)">成交</el-button>-->
                </li>
              </ul>
            </div>
          </template>
        </div>
        <div class="recommend-data-pagination">
          <el-pagination
            :current-page="recommendPagination.pageNo"
            :total="recommendPagination.total"
            :page-size="recommendPagination.pageSize"
            layout="prev, pager, next, jumper,total, sizes"
            @current-change="recommendChangeCurrent"
            @size-change="recommendChangeSize"
          />
        </div>
      </div>

      <div v-show="recommendState" class="recommend-data">
        <el-form
          ref="recommendRoutineForm"
          :model="recommendRoutineForm"
          class="recommendRoutineForm"
          :inline="true"
        >
          <div class="condition-group">
            <el-form-item label="始发地" prop="startPlace">
              <el-cascader
                v-model="recommendRoutineForm.startPlace"
                style="width:200px"
                :options="area"
                :filterable="true"
                :props="{ expandTrigger: 'hover', checkStrictly: true }"
                @expand-change="expandChange"
              />
            </el-form-item>
            <el-form-item label="目的地" prop="stopPlace">
              <el-cascader
                v-model="recommendRoutineForm.stopPlace"
                style="width:200px"
                :options="area"
                :filterable="true"
                :props="{ expandTrigger: 'hover', checkStrictly: true }"
                @expand-change="expandChange"
              />
            </el-form-item>
            <el-form-item label="运输方式" prop="transportType">
              <el-select
                v-model="recommendRoutineForm.transportType"
                style="width:150px"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item,index) in transportType"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="运输品类" prop="goodsType">
              <el-select
                v-model="recommendRoutineForm.goodsType"
                style="width:150px"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item,index) in goodsType"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item class="form-item form-item-sou">
              <el-button
                size="small"
                style="background-color: #BE2316;border-color: #F56C6C;"
                class="form-item-btn"
                type="primary"
                @click="recommendRoutineSummit"
              >
                <i class="el-icon-search" />查询
              </el-button>
              <el-button
                size="small"
                style="background-color: #BE2316;border-color: #F56C6C;"
                class="form-item-btn"
                type="primary"
                @click="resetRecommendRoutineForm"
              >
                <i class="el-icon-delete-solid" />
                重置
              </el-button>
            </el-form-item>
          </div>
        </el-form>
        <div class="recommend-data-header">
          <ul>
            <li>公司名称</li>
            <li>联系人</li>
            <li>联系人电话</li>
            <li>公司地址</li>
            <li>路线</li>
            <li>运输方式</li>
            <li>承载能力</li>
            <li>运输品类</li>
            <li>操作</li>
          </ul>
        </div>
        <div class="recommend-data-body">
          <template v-if="recommendRoutineData.length===0 && !viewManager.loading">
            <div style="text-align: center;margin-top: 1rem;">暂无匹配数据</div>
          </template>
          <template v-for="(item, index) of recommendRoutineData">
            <div :key="index" class="data-item">
              <ul>
                <li :title="item.companyName">{{ item.companyName }}</li>
                <li :title="item.shipmentName">{{ item.shipmentName }}</li>
                <li :title="item.shipmentTel">{{ item.shipmentTel }}</li>
                <li :title="item.companyAddress">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.companyAddress"
                    placement="top"
                  >
                    <span>{{ item.companyAddress }}</span>
                  </el-tooltip>
                </li>
                <li :title="item.startPlaceLabel+'至'+item.stopPlaceLabel">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.startPlaceLabel + '至' + item.stopPlaceLabel"
                    placement="top"
                  >
                    <span>{{ item.startPlaceLabel }} 至 {{ item.stopPlaceLabel }}</span>
                  </el-tooltip>
                </li>
                <li :title="item.transportTypeLabel">{{ item.transportTypeLabel }}</li>
                <li :title="item.weight">{{ item.weight }}</li>
                <li :title="item.goodsTypeLabel">{{ item.goodsTypeLabel }}</li>
                <li>
                  <el-button
                    class="yellow"
                    type="text"
                    @click="collect(item)"
                  >{{ item.favoritesFlag==='1'?'已收藏':'未收藏' }}</el-button>
                  <el-divider direction="vertical" />
                  <el-button
                    :class="[{gray:item.inviteType===1 || Number.parseInt(item.isRejectOffer)},{orange:item.inviteType!==1}]"
                    type="text"
                    style="width: 4rem"
                    :disabled="item.inviteType !== 0"
                    @click="invitationOfferShow(item)"
                  >{{ item.inviteType=='2'? Number.parseInt(item.isRejectOffer)? '拒绝报价':'已报价' :item.inviteType=='1'?'已邀请':'邀请报价' }}</el-button>
                  <!-- <el-divider direction="vertical" />
                  <el-button class="red" type="text" @click="agreeBid(item)">成交</el-button>-->
                </li>
              </ul>
            </div>
          </template>
        </div>
        <div class="recommend-data-pagination">
          <el-pagination
            :current-page="recommendRoutinePagination.pageNo"
            :total="recommendRoutinePagination.total"
            :page-size="recommendRoutinePagination.pageSize"
            layout="prev, pager, next, jumper,total, sizes"
            @current-change="recommendRoutineChangeCurrent"
            @size-change="recommendRoutineChangeSize"
          />
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { Page } from '@/utils/commonDataModel'
import { getTransportList } from '@/api/personal/find/transportManager'
import { saveList } from '@/api/personal/find/goodsInvitation'
import { getArea } from '@/api/common'
import { getDict } from '@/api/common'
import { conllection } from '@/api/cloud/storage-demand-info/storageDemandInfo'
import mixinsFunction from '@/utils/mixinsFunction'
export default {
  name: 'TransportRecommend',
  mixins: [mixinsFunction],
  data: function() {
    return {
      recommendState: false,
      recommendData: [],
      recommendRoutineData: [],
      recommendRoutineParam: {},
      recommendRoutineForm: {},
      // 智能推荐分页
      recommendPagination: new Page(),
      // 常规推荐分页
      recommendRoutinePagination: new Page(),
      // 运输方式
      transportType: [],
      area: [],
      goodsType: [],
      recommendParam: {},
      offerShow: true
    }
  },
  created: function() {
    this.getArea()
    this.getDict()
  },
  mounted() {
    document.onkeydown = (e) => {
      // console.log(e)
      if (e.keyCode === 13) {
        this.recommendRoutineSummit()
      }
    }
  },
  methods: {
    // 打开弹出框
    async open(goods) {
      this.recommendParam = goods
      this.recommendRoutineParam.goodsId = this.recommendParam.id
      this.viewManager.visible = true
      this.load()
    },
    async load() {
      await this.loadRecommendData()
      await this.loadRecommendRoutineData()
    },
    // 转换参数
    exchangeData(data) {
      const handle = {
        get(target, key, proxy) {
          if (
            (key === 'startPlace' || key === 'stopPlace') &&
            target[key] &&
            target[key].length > 0
          ) {
            return target[key] instanceof Object
              ? target[key].length === 1
                ? target[key].join('#')
                : target[key].join('#') + '#'
              : target[key]
          } else {
            return target[key]
          }
        }
      }
      if (window && window.Proxy) {
        const p = new Proxy(data, handle)
        const proxyData = Object.assign({}, p)
        return proxyData
      } else {
        const proxyData = {}
        for (const key in data) {
          proxyData[key] = handle.get(data, key)
        }
        return proxyData
      }
    },
    // agreeBid(id) {
    //   console.log(id)
    // },
    // 收藏
    collect(item) {
      // 请求未完成时重复点击
      if (item.collectionSubmit) {
        return false
      }
      item.collectionSubmit = true
      const favoritesFlag = item.favoritesFlag === '1' ? '2' : '1'
      // 发起收藏?取消收藏的请求
      conllection({
        id: item.collectionId,
        moduleId: item.id,
        moduleType: '2',
        collectionStatus: favoritesFlag
      })
        .then(data => {
          item.favoritesFlag = favoritesFlag
          item.collectionId = data.result.id
          this.$message({
            message: item.favoritesFlag == '1' ? '收藏成功' : '取消收藏成功',
            type: item.favoritesFlag == '1' ? 'success' : 'warning'
          })
          item.collectionSubmit = false
        })
        .catch(error => {
          console.error(error)
          item.collectionSubmit = false
        })
    },
    //  邀请报价的http请求
    invitationOfferShow(item) {
      if (this.offerShow == true) {
        this.offerShow = false
        const params = {
          goodsIds: this.recommendParam.id,
          goodsNames: this.recommendParam.goodsName,
          companyName: this.recommendParam.companyName,
          nickName: this.recommendParam.contacter,
          contactTel: this.recommendParam.contacterTel,
          transportUserId: item.userId
        }
        saveList(params)
          .then(data => {
            this.$message({
              type: 'success',
              message: '邀请成功!'
            })
            this.offerShow = true
            this.load()
          })
          .catch(error => {
            console.error(error)
          })
          .finally(() => {})
      }
    },
    resetRecommendRoutineForm() {
      this.$refs['recommendRoutineForm'].resetFields()
      this.recommendRoutineParam = this.exchangeData(this.recommendRoutineForm)
      this.recommendRoutineParam.goodsId = this.recommendParam.id
      this.loadRecommendRoutineData()
    },
    toggleRecommendState() {
      this.recommendState = !this.recommendState
    },
    getArea() {
      return getArea()
        .then(data => {
          this.area = data.result
        })
        .catch(error => {
          console.error(error)
        })
    },
    async getDict() {
      getDict('goodsType')
        .then(data => {
          this.goodsType = JSON.parse(data.result)
        })
        .catch(error => {
          console.error(error)
        })
      getDict('transportType')
        .then(data => {
          this.transportType = JSON.parse(data.result)
        })
        .catch(error => {
          console.error(error)
        })
    },
    loadRecommendData() {
      const param = {}
      param.goodsId = this.recommendParam.id
      param.goodsType = this.recommendParam.goodsType
      param.startPlace = this.recommendParam.startPlace
      param.stopPlace = this.recommendParam.stopPlace
      this.viewManager.loading = true
      return getTransportList(this.recommendPagination, param)
        .then(data => {
          this.recommendData = data.result.rows
          this.recommendPagination.total = data.result.total
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
          this.viewManager.loading = false
        })
    },
    loadRecommendRoutineData() {
      var param = this.recommendRoutineParam
      this.viewManager.loading = true
      return getTransportList(this.recommendRoutinePagination, param)
        .then(data => {
          this.recommendRoutineData = data.result.rows
          this.recommendRoutinePagination.total = data.result.total
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
          this.viewManager.loading = false
        })
    },
    recommendChangeSize(size) {
      this.recommendPagination.pageSize = size
      this.loadRecommendData()
    },
    recommendChangeCurrent(current) {
      this.recommendPagination.pageNo = current
      this.loadRecommendData()
    },
    recommendRoutineChangeSize(size) {
      this.recommendRoutinePagination.pageSize = size
      this.loadRecommendRoutineData()
    },
    recommendRoutineChangeCurrent(current) {
      this.recommendRoutinePagination.pageNo = current
      this.loadRecommendRoutineData()
    },
    recommendRoutineSummit() {
      this.recommendRoutineParam = this.exchangeData(this.recommendRoutineForm)
      this.recommendRoutineParam.goodsId = this.recommendParam.id
      this.loadRecommendRoutineData()
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/styles/standardColor.scss";

$main-color: #be2316;
.recommend-dialog-head {
  box-sizing: border-box;
  border-style: solid;
  border-width: 0 0 1px 0;
  border-color: #f1f1f1;
  background-color: #ffffff;
  .slider-list {
    display: block;
    margin: 0 0;
    height: 36px;
    overflow: auto;
    white-space: nowrap;
    border-bottom: 1px solid #f1f1f1;
    &::-webkit-scrollbar {
      height: 0px !important;
      width: 0px !important;
    }
    &::-moz-scrollbar {
      height: 0px !important;
      width: 0px !important;
    }
    .item {
      // height: 35px;
      height: calc(100% - 1px);
      display: inline-block;
      width: 100px;
      font-size: 16px;
      font-weight: 600;
      line-height: 35px;
      margin-right: 12px;
      border-bottom: 1px solid rgba(0, 0, 0, 0);
      text-align: center;
      transition: all 1s;
      color: black;
      cursor: pointer;

      &.selected {
        border-bottom: 1px solid $main-color;
        transition: all 1s;
        color: $main-color;
      }
    }
  }
  .goods-head-form {
    padding-top: 1rem;
    display: flex;
    .fileds {
      flex: 0 1 75%;
      /deep/ .el-form-item {
        label:after {
          content: " : ";
        }
      }
    }
    .buttons {
      flex: 0 1 25%;
      display: inherit;
      align-items: center;
      justify-content: center;
    }
  }
}
.recommend-data {
  .recommendRoutineForm {
    .condition-group {
      margin-top: 0.5rem;
      padding-left: 8px;
    }
  }
  .recommend-data-header {
    margin-top: 24px;
    color: $main-color;
    font-weight: bold;
    background-color: #ffffff;
    height: 51px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.09);
    border-radius: 4px;
    ul {
      display: flex;
      flex-wrap: nowrap;
      height: 100%;
      width: calc(100% - 16px);
      padding: 8px 8px;
      box-sizing: content-box;
      li {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 15px;
        min-width: 50px;
        height: 100%;
        line-height: 29px;
        text-align: center;
        &:nth-child(1) {
          flex-basis: 10%;
        }
        &:nth-child(2) {
          flex-basis: 10%;
        }
        &:nth-child(3) {
          flex-basis: 10%;
        }
        &:nth-child(4) {
          flex-basis: 10%;
        }
        &:nth-child(5) {
          flex-basis: 25%;
        }
        &:nth-child(6) {
          flex-basis: 10%;
        }
        &:nth-child(7) {
          flex-basis: 10%;
        }
        &:nth-child(8) {
          flex-basis: 10%;
        }
        &:nth-child(9) {
          flex-basis: 25%;
        }
      }
    }
  }
  .recommend-data-body {
    position: relative;
    .no-data-info {
      background-color: #fff;
      width: 100%;
      text-align: center;
      margin-top: 8px;
      height: 51px;
      line-height: 51px;
      font-size: 15px;
    }
    .data-item {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.09);
      border-radius: 4px;
      margin: 8px 0px;
      position: relative;
      box-sizing: border-box;
      ul {
        display: flex;
        flex-wrap: nowrap;
        width: 100%;
        height: 56px;
        position: relative;
        background-color: white;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        *::selection {
          background-color: rgba(0, 0, 0, 0) !important;
        }
        li {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 15px;
          min-width: 50px;
          height: 100%;
          line-height: 56px;
          text-align: center;
          &:nth-child(1) {
            flex-basis: 10%;
          }
          &:nth-child(2) {
            flex-basis: 10%;
          }
          &:nth-child(3) {
            flex-basis: 10%;
          }
          &:nth-child(4) {
            flex-basis: 10%;
          }
          &:nth-child(5) {
            flex-basis: 25%;
          }
          &:nth-child(6) {
            flex-basis: 10%;
          }
          &:nth-child(7) {
            flex-basis: 10%;
          }
          &:nth-child(8) {
            flex-basis: 10%;
          }
          &:nth-child(9) {
            flex-basis: 25%;
          }
        }
      }
      /deep/ .goods-item-details {
        border: 1px solid #ebeef5;
        z-index: 0;
      }
      .yellow {
        color: #e88e00;
      }
      .orange {
        color: #e3530c;
      }
      .gray {
        color: #b3b3b3;
      }
      .red {
        color: #bf2316;
      }
    }
  }
  .recommend-data-pagination {
    margin-top: 24px;
    padding: 16px 0px;
    background-color: white;
  }
}
</style>
